// "Allocated X minutes ago" label + escalating colour for picking timers.
// yellow at >=10 min, red at >=20 min after allocation.
export function allocatedInfo(iso, nowMs) {
  if (!iso) return null;
  const mins = Math.floor((nowMs - new Date(iso).getTime()) / 60000);
  const text = mins < 1 ? "Allocated just now" : `Allocated ${mins} min${mins !== 1 ? "s" : ""} ago`;
  const cls = mins >= 20 ? "text-red-600 font-semibold"
            : mins >= 10 ? "text-amber-600 font-semibold"
            : "text-gray-400";
  return { mins, text, cls };
}
